var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcTopicVideos(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.36,
    height: 18.36,
    viewBox: "0 0 18.36 18.36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "subscriptions_FILL0_wght400_GRAD0_opsz48",
    d: "M5.339,21.86A1.373,1.373,0,0,1,4,20.52V10.7A1.373,1.373,0,0,1,5.339,9.358H20.52A1.373,1.373,0,0,1,21.86,10.7V20.52a1.373,1.373,0,0,1-1.34,1.34Zm0-1.34H20.52V10.7H5.339ZM11.3,18.935l4.934-3.326L11.3,12.3ZM5.54,8.019V6.679H20.32v1.34ZM8.465,5.339V4H17.4V5.339ZM5.339,20.52v0Z",
    transform: "translate(-3.75 -3.75)",
    stroke: "#000",
    strokeWidth: 0.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTopicVideos);
export default __webpack_public_path__ + "static/media/ic_topic-videos.28d23ef8e5779cfd942df42c4ba90f8e.svg";
export { ForwardRef as ReactComponent };